"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.packageInfo = void 0;
exports.packageInfo = { name: '@polkadot/wasm-crypto-init', path: typeof __dirname === 'string' ? __dirname : 'auto', type: 'cjs', version: '7.2.1' };
